import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';

import { AngularSvgIconModule } from 'angular-svg-icon';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';

import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';

import { HttpErrorHandlingInterceptor } from './interceptors/http-error-handling.interceptor';

import { CoreModule } from './modules/core/core.module';
import { MainComponent } from './modules/core/main/main.component';
import { AngularFireModule } from '@angular/fire/compat';
import { environment } from 'src/environments/environment';

@NgModule({
  declarations: [ ],
  imports: [
    BrowserModule,
    CoreModule,
    HttpClientModule,
    BrowserAnimationsModule,
    AngularSvgIconModule.forRoot(),
    TranslateModule.forRoot(
      {
        loader:
        {
          provide: TranslateLoader,
          useFactory: HttpTranslateLoader,
          deps: [HttpClient]
        }
      }
    ),
    ServiceWorkerModule.register('assets/PWA/ngsw-worker.js', { enabled: true, registrationStrategy: 'registerImmediately' }),
    AngularFireModule.initializeApp(environment.firebaseConfig),
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorHandlingInterceptor, multi: true }
  ],
  exports: [TranslateModule],
  bootstrap: [MainComponent]
})
export class AppModule { }

export function HttpTranslateLoader(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http);
}
